<template>
  <v-row no-gutters>
    <v-col cols="12" v-if="isFetched">
      <v-row no-gutters class="py-2">
        <v-col cols="auto" class="pl-3">
          <file-input
            class="icon-upload"
            ref="file"
            button-icon=""
            button-translation-path="button.importIcon"
            :buttonSubheaders="['button.importIconSubheader']"
            :options="dropzoneOptions"
            :show-added-files="false"
            :events="{
              'vdropzone-success': onUploadSuccess,
              'vdropzone-error': onError,
            }"
          >
          </file-input>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-container>
          <v-row class="justify-start">
            <v-col v-for="(icon, idx) in icons" :key="idx" class="col-sm-12 col-md-6 col-lg-2 col-xl-2">
              <icon-tile :icon="icon" />
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-col>
    <template v-else>
      <main-loader />
    </template>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import FileInput from '@/components/FileInput';
import IconTile from '@/components/IconTile';
import MainLoader from '@/components/MainLoader';
export default {
  name: 'IconsDialog',
  components: {
    FileInput,
    IconTile,
    MainLoader,
  },
  computed: {
    icons: get('layers/icons'),
    dropzoneOptions() {
      return {
        url: `${process.env.VUE_APP_API_URL}/icons`,
        method: 'post',
        acceptedFiles: '.svg,.png',
        autoProcessQueue: true,
        uploadMultiple: false,
        addRemoveLinks: false,
        paramName: 'file',
        maxFiles: 1,
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getIcons: call('layers/getIcons'),
    async getIconsHandler() {
      try {
        await this.getIcons();
        this.isFetched = true;
      } catch {
        this.isFetched = true;
      }
    },
    async init() {
      await this.getIconsHandler();
    },
    onError() {
      this.$refs.file.$refs.dropzone.removeAllFiles();
    },
    onUploadSuccess() {
      this.$refs.file.$refs.dropzone.removeAllFiles();
      this.getIconsHandler();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .icon-upload .dz-preview {
    display: none;
  }
}
</style>
